<template>
  <div class="event">
    <p>{{ $store.getters['getClientMeta'].name }}</p>
    <h3 class="line-title">Arkadaşına Gönder</h3>
    <div class="user-content-inc">
      <div class="send-friend">
        <div class="content friend">
          <div class="alert alert-success">
            <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
            Arkadaşınızı arayın ve para gönderin !
          </div>
          <slot v-if="!is_search">
             <form @submit.prevent="searchUser">
                <p>Arkadaşınıza Para Gönderin</p>
                <div class="row inputs direction-column">
                    <div class="col"><input v-model="username" type="text" placeholder="Arkadaşınızın kullanıcı adı"></div>
                    <div class="col">
                      <ButtonLoader class="primary" :loader="loading" :text="'Arama Yap'">
                        <template name="icon">
                          <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                        </template>
                      </ButtonLoader>
                    </div>
                </div>
            </form>
          </slot>
          <slot v-else>
               <form @submit.prevent="makeTransfer">
                  <p>Hesap Bulundu: {{ user_name }} - {{ user_email }} </p>
                  <div class="row inputs direction-column">
                      <div class="col">
                          <input v-model="form.amount" type="number" placeholder="Tutar"/>
                      </div>
                      <div class="col">
                        <ButtonLoader class="primary" :loader="loading" :text="'Arkadaşına Gönder'" >
                          <template name="icon">
                            <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                          </template>
                        </ButtonLoader>
                      </div>
                  </div>
               </form>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '../../components/Common/User/Header'
  export default{
    data(){
      return{
        username : null,
        loading: null,
        is_search: false,
        form:{
          user_id: null,
          amount: null
        },
        user_email:null,
        user_name:null,
        user_fullname:null,
      }
    },
    components:{
      Header
    },
    methods: {
      searchUser(){
        this.loading = true;
        axios.get('/user/wallet/transfer', { params: { username: this.username } })
        .then((response) => {
          if(response.status){
            this.is_search 		= true;
            this.form.user_id 	= response.data.user_id;
            this.user_email 	= response.data.email;
            this.user_name 		= response.data.username;
            this.user_fullname 	= response.data.fullname;
          }
        })
        .catch((err) => {
        })
        .finally(() => {
          this.loading = false;
        });
      },
      makeTransfer(){
        this.loading = true;
        axios.post('/user/wallet/transfer', this.form)
        .then((response) => {
          this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message });
        })
        .catch((err) => {
        })
        .finally(() => {
          this.loading = false;
        });
      }
    }
  }
</script>